/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTournamentBracketSettings
 */
export interface UpdateTournamentBracketSettings {
    /**
     * 
     * @type {string}
     * @memberof UpdateTournamentBracketSettings
     */
    seeding?: UpdateTournamentBracketSettingsSeedingEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTournamentBracketSettings
     */
    thirdPlaceMatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTournamentBracketSettings
     */
    grandFinalAdvantage?: boolean;
}


/**
 * @export
 */
export const UpdateTournamentBracketSettingsSeedingEnum = {
    random: 'random',
    ranked: 'ranked',
    manual: 'manual'
} as const;
export type UpdateTournamentBracketSettingsSeedingEnum = typeof UpdateTournamentBracketSettingsSeedingEnum[keyof typeof UpdateTournamentBracketSettingsSeedingEnum];


/**
 * Check if a given object implements the UpdateTournamentBracketSettings interface.
 */
export function instanceOfUpdateTournamentBracketSettings(value: object): value is UpdateTournamentBracketSettings {
    return true;
}

export function UpdateTournamentBracketSettingsFromJSON(json: any): UpdateTournamentBracketSettings {
    return UpdateTournamentBracketSettingsFromJSONTyped(json, false);
}

export function UpdateTournamentBracketSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTournamentBracketSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'seeding': json['seeding'] == null ? undefined : json['seeding'],
        'thirdPlaceMatch': json['thirdPlaceMatch'] == null ? undefined : json['thirdPlaceMatch'],
        'grandFinalAdvantage': json['grandFinalAdvantage'] == null ? undefined : json['grandFinalAdvantage'],
    };
}

export function UpdateTournamentBracketSettingsToJSON(json: any): UpdateTournamentBracketSettings {
    return UpdateTournamentBracketSettingsToJSONTyped(json, false);
}

export function UpdateTournamentBracketSettingsToJSONTyped(value?: UpdateTournamentBracketSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seeding': value['seeding'],
        'thirdPlaceMatch': value['thirdPlaceMatch'],
        'grandFinalAdvantage': value['grandFinalAdvantage'],
    };
}

